import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import Helper from '../../Helper';
import Alert from '../sub/dialog';
import moment from 'moment';
import './Bill.css'; // Import CSS for print styling
import PrintHeader from './sub/PrintHeader';
import PrintFooter from './sub/PrintFooter';
import { Previewer } from 'pagedjs';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';


const TransportPrint = ({ data }) => {
    const navigate = useNavigate();

    const [company, setCompany] = useState({
        name: '',
        name_en: '',
        address: '',
        phone: '',
        email: '',
        website: '',
        taxid: '', bankaccount: '', bankaccountname: '', bankname: '', bankaccounttype: ''

    });

    const [itemperpagesummary, setitemperpagesummary] = useState(6);
    const [itempagesummary, setitempagesummary] = useState(6);
    const [itemperpage, setitemperpage] = useState(12);
    const [userinfo, setUserinfo] = useState({});
    const [customer, setCustomer] = useState({});
    const alert = useRef();
    const printRef = useRef();
    let { name, id } = useParams();
    const [summarydata, setSummarydata] = useState({});
    const [transportAccount, setTransportAccount] = useState({});
    const [transportJobList, setTransportJobList] = useState([]);
    const setError = (message) => alert.current.showerror(message);
    const header = { name: "ใบแจ้งหนี้" }
    const handlePrint = useReactToPrint({
        documentTitle: header.name,
        contentRef: printRef,
    });


    const getTransportAccount = async (transportname) => {

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportAccount/${transportname}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (!data.transportAccount) {
                    setError('ไม่มีข้อมูลการขนส่ง');
                    return;
                }

                setSummarydata({
                    totalamount: data.transportAccount.totalamount,
                    totalnetamount: data.transportAccount.totalnetamount,
                    totalvatamount: data.transportAccount.totalvatamount,
                    totalwhtamount: data.transportAccount.totalwhtamount,
                    totalpaidamount: data.transportAccount.totalpaidamount
                });
                //setTransportAccount(data.transportAccount);
                fetchCustomer(data.transportAccount.customerid);
                fetchuser(data.transportAccount.modify_user);
                getTransportJobList(data.transportAccount);

            } else {
                const data = await response.json();
                setError(data.message || 'Failed to fetch transport list');
            }
        } catch (err) {
            setError('An error occurred while fetching the transport list.');
        }
    }


    const getTransportJobList = async (transport) => {


        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getTransportJobListById/${transport.id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                var result = data.transportJobList.flatMap(el => el.bills).filter(el => el.isbillitem == 1)
                if (result.length == 0) {
                    setError('ไม่มีข้อมูลการขนส่ง');
                    return;
                }
                var account = transport;
                var list = data.transportJobList;
                var unique = [...new Set(list.map(item => item.jobname))]
                account.remark += '\nJob: ' + unique.join(",");
                unique = [...new Set(list.filter(el => el.bl).map(item => item.bl))]
                account.remark += '\nB/L Booking NO.: ' + unique.join(",");

                const countMap = list.filter(el => el.boxsize).reduce((acc, item) => {
                    acc[item.boxsize] = (acc[item.boxsize] || 0) + 1;
                    return acc;
                }, {});

                account.remark += '\nVol.: ' + Object.entries(countMap)
                    .map(([size, count]) => `${count}x${size}`)
                    .join(', ');
                setTransportAccount({ ...account });

                var itempage = Helper.calculateline(result, itemperpage)
                var itempagesummary = Helper.calculateline(result, itemperpagesummary);
                setitemperpage(itempage);
                setitempagesummary(itempagesummary);
                setTransportJobList(result);




            } else {
                const data = await response.json();
                setError(data.message || 'Failed to fetch transport list');
            }
        } catch (err) {
            setError('An error occurred while fetching the transport list.');
        }
    }
    const fetchCustomer = async (customerid) => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Getcustomerbyid/${customerid}`, {
                headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
            });
            const data = await response.json();
            if (data && data.customer) setCustomer(data.customer);
        } catch (error) {
            setError('Error fetching customer profile:', error);
        }
    };
    const fetchuser = async (username) => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/Getuserinfo/${username}`, {
                headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
            });
            const data = await response.json();
            if (data && data.userinfo) setUserinfo(data.userinfo);
        } catch (error) {
            setError('Error fetching customer profile:', error);
        }
    };
    const fetchCompany = async () => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/GetcompanyProfile`, {
                headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
            });
            const data = await response.json();
            if (data) setCompany(data);
        } catch (error) {
            setError('Error fetching company profile:', error);
        }
    };



    useEffect(() => {
        // Get the token from sessionStorage


        if (!["account", "billing", "admin"].includes(Helper.getuserrole())) {
            navigate('/main');
            return;
        }
        if (!name) {
            navigate('/main');
            return;
        }
        fetchCompany();
        getTransportAccount(name);

        // Initialize Paged.js preview after all data is loaded

    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', flexDirection: 'column' }}>
            <style type="text/css" media="print">{"\
  @page {\ size:A4;\ }\
"}</style>
            <Alert ref={alert} />
            <button className='btn btn-info mb-4 mt-4' onClick={handlePrint}>Print</button>

            <div ref={printRef} className="bill print-container"  >



                {Array.from({ length: Math.ceil(transportJobList.length / itemperpage) }, (_, pageIndex) => (
                    <div key={pageIndex} className="print-page mb-2">
                        <PrintHeader company={company}
                            header={{ ...header, title: "ต้นฉบับ", page: `หน้า ${pageIndex + 1}/${Math.ceil(transportJobList.length / itemperpage) + (Math.ceil(transportJobList.length / itemperpage) && transportJobList.length % itemperpage < itempagesummary ? 0 : 1)}` }}
                            transportAccount={transportAccount}
                            customer={customer}
                            userinfo={userinfo}
                        />
                        <div className="print-content">
                            <MDBTable className='header-table'>
                                <MDBTableHead style={{ backgroundColor: '#f2f2f2' }}>
                                    <tr>
                                        <th colSpan={2}>คำอธิบาย</th>
                                        <th style={{ textAlign: "right" }}>จำนวน</th>
                                        <th style={{ textAlign: "right" }}>ราคา</th>
                                        <th style={{ textAlign: "right" }}>VAT</th>
                                        <th style={{ textAlign: "right", whiteSpace: "nowrap" }}>มูลค่าก่อนภาษี</th>
                                        <th style={{ textAlign: "right" }}>WHT</th>
                                    </tr>
                                </MDBTableHead>
                                <MDBTableBody>
                                    {transportJobList.slice(pageIndex * itemperpage, (pageIndex + 1) * itemperpage).map((job, subIndex) => (
                                        <tr key={subIndex}>
                                            <td>{pageIndex * itemperpage + subIndex + 1}</td>
                                            <td style={{ whiteSpace: "pre-wrap" }}>{job.item}</td>
                                            <td style={{ textAlign: "right" }}>{job.qty ?? 1}</td>
                                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(job.amount)}</td>
                                            <td style={{ textAlign: "right" }}>{parseFloat(job.vatamount) == 0 ? "ไม่มี" : Helper.formatnumber(job.vatamount)}</td>
                                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(job.totalamount)}</td>
                                            <td style={{ textAlign: "right" }}>{Helper.formatnumber(job.whtamount)}</td>
                                        </tr>
                                    ))}
                                </MDBTableBody>
                            </MDBTable>
                        </div>
                        {pageIndex + 1 === Math.ceil(transportJobList.length / itemperpage) && transportJobList.length % itemperpage != 0 && transportJobList.length % itemperpage < itempagesummary ? (
                            <PrintFooter transportAccount={transportAccount}
                                transportJobList={transportJobList}
                                customer={customer}
                                company={company}
                                userinfo={userinfo} header={{ LastPage: true }} />
                        ) : null}
                    </div>
                ))}

                {(transportJobList.length % itemperpage >= itempagesummary || transportJobList.length % itemperpage == 0) && (
                    <div className="print-page mb-2">
                        <PrintHeader company={company}
                            header={{ ...header, title: "ต้นฉบับ", page: `หน้า ${Math.ceil(transportJobList.length / itemperpage) + 1}/${Math.ceil(transportJobList.length / itemperpage) + 1}` }}
                            transportAccount={transportAccount}
                            customer={customer}
                            userinfo={userinfo}
                        />

                        <PrintFooter transportAccount={transportAccount}
                            transportJobList={transportJobList}
                            customer={customer}
                            company={company}
                            userinfo={userinfo} header={{ LastPage: true }} />
                    </div>
                )}

            </div>
        </div >
    );
};

export default TransportPrint;